// Mobile View Start -----------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.mobile-view-btn-tab');
  const divs = document.querySelectorAll('.stone-item, .color-range-item, .clarity-range-item, .cut-range-item');

  // Check if elements exist before proceeding
  if (!buttons.length) {
    return;
  }

  function handleTabClick(event) {
    const button = event.currentTarget;
    const tabValue = button.querySelector('.tab-selected-value');

    // Validate elements exist
    if (!button || !tabValue) {
      return;
    }

    // Hide all tab values
    buttons.forEach(btn => {
      const btnTabValue = btn.querySelector('.tab-selected-value');
      if (btnTabValue) {
        btnTabValue.classList.add('tab-hidden');
      }
      btn.classList.remove('active');
      btn.style.backgroundColor = '';
    });

    // Show the selected tab value
    tabValue.classList.remove('tab-hidden');
    button.classList.add('active');

    // Hide all content divs
    divs.forEach(div => {
      if (div) {
        div.classList.add('tab-hidden');
      }
    });

    // Show the appropriate content block based on button ID
    let targetBlock = null;
    switch (button.id) {
      case 'carat-tab-btn':
        targetBlock = document.querySelector('.carat-rang-block');
        break;
      case 'color-tab-btn':
        targetBlock = document.querySelector('.color-rang-block');
        break;
      case 'clarity-tab-btn':
        targetBlock = document.querySelector('.clarity-rang-block');
        break;
      case 'cut-tab-btn':
        targetBlock = document.querySelector('.cut-rang-block');
        break;
    }

    if (targetBlock) {
      targetBlock.classList.remove('tab-hidden');
    }
  }

  // Function to add event listeners
  function addTabEventListeners() {
    buttons.forEach(button => {
      // Remove existing listener to prevent duplication
      button.removeEventListener('click', handleTabClick);
      button.addEventListener('click', handleTabClick);
    });
  }

  // Function to remove event listeners
  function removeTabEventListeners() {
    buttons.forEach(button => {
      button.removeEventListener('click', handleTabClick);
    });
  }

  // Initialize tabs only on mobile
  function initializeMobileTabs() {
    if (window.innerWidth <= 767) {
      addTabEventListeners();

      // Set default active tab
      const defaultButton = document.getElementById('carat-tab-btn');
      if (defaultButton) {
        // Trigger click on default button to initialize the view
        defaultButton.click();
      }
    } else {
      removeTabEventListeners();
    }
  }

  // Add resize event listener
  window.addEventListener('resize', initializeMobileTabs);

  // Initial setup
  initializeMobileTabs();
});

// Carat File JS -------------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.stone-item--slider');
  const thumbFill = document.querySelector('.stone-item--btn-inner');
  const diamond = document.querySelector('.stone-item--image');
  const labels = document.querySelectorAll('.stone-item--rang-label');
  const btn = document.querySelector('.stone-item--btn');
  const initialValueElement = document.querySelector('.stone-item-title-value');

  const values = [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0];
  const min = values[0];
  const max = values[values.length - 1];
  const steps = values.length - 1;

  function snapToDefinedValue(rawValue) {
    const numeric = typeof rawValue === 'number' ? rawValue : parseFloat(rawValue);
    if (Number.isNaN(numeric)) return values[0];
    if (numeric <= values[0]) return values[0];
    if (numeric >= values[values.length - 1]) return values[values.length - 1];
    let closest = values[0];
    let smallestDelta = Math.abs(numeric - closest);
    for (let i = 1; i < values.length; i += 1) {
      const delta = Math.abs(numeric - values[i]);
      if (delta < smallestDelta) {
        smallestDelta = delta;
        closest = values[i];
      }
    }
    return closest;
  }

  function calculatePercentage(value) {
    const index = values.indexOf(value);
    return (index / steps) * 100;
  }

  function getScale(value) {
    if (value >= 0.5 && value <= 0.99) return 0.9;
    if (value >= 1.0 && value <= 1.49) return 1;
    if (value >= 1.5 && value <= 1.99) return 1.1;
    if (value >= 2.0 && value <= 2.99) return 1.2;
    if (value >= 2.5 && value <= 2.99) return 1.3;
    if (value >= 3.0 && value <= 3.99) return 1.4;
    if (value >= 3.5 && value <= 3.99) return 1.5;
    if (value >= 4.0 && value <= 4.99) return 1.6;
    if (value >= 4.5 && value <= 4.99) return 1.7;
    if (value === 5.0) return 1.7;
    return 1;
  }

  function updateSlider(value) {
    const snappedValue = snapToDefinedValue(value);
    const percentage = calculatePercentage(snappedValue);

    const validPercentage = Math.min(Math.max(percentage, 0), 100);
    slider.style.left = `calc(${validPercentage}% - 10px)`;
    thumbFill.style.background = `linear-gradient(to right, black ${validPercentage}%, #fff ${validPercentage}%)`;

    labels.forEach(label => label.classList.remove('active'));
    const activeIndex = values.indexOf(snappedValue);
    if (activeIndex !== -1) labels[activeIndex].classList.add('active');

    const scale = getScale(snappedValue);
    diamond.style.transform = `scale(${scale})`;
  }

  function getClosestValue(position, maxPosition) {
    const percentage = position / maxPosition;
    const validPercentage = Math.min(Math.max(percentage, 0), 1);
    const closestIndex = Math.round(validPercentage * steps);
    return values[closestIndex];
  }

  function handleSliderClick(event) {
    const sliderWidth = btn.clientWidth;
    const sliderLeft = btn.getBoundingClientRect().left;
    const clientX = event.type.startsWith('touch') ? event.touches[0].clientX : event.clientX;
    const newPosition = clientX - sliderLeft;
    const closestValue = getClosestValue(newPosition, sliderWidth);
    updateSlider(closestValue);
  }

  labels.forEach((label, index) => {
    label.addEventListener('click', function () {
      const value = values[index];
      updateSlider(value);
    });
  });

  slider.addEventListener('mousedown', function () {
    function onMouseMove(event) {
      handleSliderClick(event);
    }

    function onMouseUp() {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  });

  slider.addEventListener('touchstart', function (event) {
    event.preventDefault();
    function onTouchMove(event) {
      handleSliderClick(event);
    }

    function onTouchEnd() {
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    }

    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
  });

  btn.addEventListener('click', function (event) {
    handleSliderClick(event);
  });

  btn.addEventListener('touchend', function (event) {
    handleSliderClick(event);
  });

  // Initialize from initial value element, fall back to min
  let initialRaw = min;
  if (initialValueElement && typeof initialValueElement.textContent === 'string') {
    // Extract numeric part, allow decimals
    const extracted = initialValueElement.textContent.trim().replace(/[^0-9.]/g, '');
    const parsed = parseFloat(extracted);
    initialRaw = Number.isNaN(parsed) ? min : parsed;
  }
  const initialSnapped = snapToDefinedValue(initialRaw);
  updateSlider(initialSnapped);
});

// Color File JS -------------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.color-item--slider');
  const colorImage = document.querySelector('.color-item--image');
  const labels = document.querySelectorAll('.color-item--rang-label');
  const contentItems = document.querySelectorAll('.color-item--content-inner');
  const thumb = document.querySelector('.color-item--btn-inner');
  const track = document.querySelector('.color-item--btn');
  const initialValueElement = document.querySelector('.color-item-head-value');

  const diamondColors = ["J", "I", "H", "G", "F", "E", "D"];
  const maxLabelIndex = labels.length - 1;
  let currentLabelIndex = 0;
  let isDragging = false;

  function updateOpacity(index) {
    if (index <= 1) {
      colorImage.style.opacity = '1';
      contentItems[0].style.display = 'block';
      contentItems[1].style.display = 'none';
      contentItems[2].style.display = 'none';
    } else if (index <= 3) {
      colorImage.style.opacity = '0.5';
      contentItems[0].style.display = 'none';
      contentItems[1].style.display = 'block';
      contentItems[2].style.display = 'none';
    } else {
      colorImage.style.opacity = '0';
      contentItems[0].style.display = 'none';
      contentItems[1].style.display = 'none';
      contentItems[2].style.display = 'block';
    }
  }

  function updateActiveLabel(index) {
    labels.forEach((label, i) => {
      if (i === index) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    });
  }

  function updateThumbGradient(index) {
    const percentage = (index / maxLabelIndex) * 100;
    thumb.style.background = `linear-gradient(to right, rgb(0, 0, 0) ${percentage}%, rgb(255, 255, 255) ${percentage}%)`;
  }

  function updateAriaValueNow(index) {
    const valueNow = diamondColors[index];
    slider.setAttribute('aria-valuenow', valueNow);
  }

  function moveSliderTo(index) {
    const percentage = (index / maxLabelIndex) * 100;
    slider.style.left = `calc(${percentage}% - 0px)`;
    updateOpacity(index);
    updateActiveLabel(index);
    updateThumbGradient(index);
    updateAriaValueNow(index);
  }

  function getClosestValue(position, sliderWidth) {
    const labelWidth = sliderWidth / maxLabelIndex;
    return Math.round(position / labelWidth);
  }

  function handleSliderInteraction(event) {
    const sliderWidth = track.clientWidth;
    const clientX = event.type.startsWith('touch') ? event.touches[0].clientX : event.clientX;
    const rect = track.getBoundingClientRect();
    const newPosition = clientX - rect.left;
    const closestValue = getClosestValue(newPosition, sliderWidth);

    if (closestValue >= 0 && closestValue <= maxLabelIndex) {
      currentLabelIndex = closestValue;
      moveSliderTo(currentLabelIndex);
    }
  }

  function startDrag(event) {
    isDragging = true;
    document.addEventListener('mousemove', handleSliderInteraction);
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchmove', handleSliderInteraction);
    document.addEventListener('touchend', endDrag);
    handleSliderInteraction(event); // Ensure the slider moves immediately on drag start
  }

  function endDrag() {
    isDragging = false;
    document.removeEventListener('mousemove', handleSliderInteraction);
    document.removeEventListener('mouseup', endDrag);
    document.removeEventListener('touchmove', handleSliderInteraction);
    document.removeEventListener('touchend', endDrag);
  }

  slider.addEventListener('mousedown', startDrag);
  slider.addEventListener('touchstart', startDrag);

  track.addEventListener('click', function (event) {
    handleSliderInteraction(event);
  });

  labels.forEach((label, index) => {
    label.addEventListener('click', function () {
      currentLabelIndex = index;
      moveSliderTo(currentLabelIndex);
    });
  });

  window.addEventListener('resize', function () {
    moveSliderTo(currentLabelIndex);
  });

  const defaultIndex = diamondColors.indexOf('D') !== -1 ? diamondColors.indexOf('D') : maxLabelIndex;
  if (initialValueElement) {
    const initialValue = initialValueElement.textContent.trim();
    const initialIndex = diamondColors.indexOf(initialValue);
    currentLabelIndex = initialIndex !== -1 ? initialIndex : defaultIndex;
  } else {
    currentLabelIndex = defaultIndex;
  }

  moveSliderTo(currentLabelIndex);
});

// Clarity file Js ----------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const sliderCircle = document.querySelector('.clarity-item--slider');
  const sliderTrack = document.querySelector('.clarity-item--btn-inner');
  const images = document.querySelectorAll('.clarity-item-main--image');
  const contentItems = document.querySelectorAll('.clarity-item--content-inner');
  const labels = document.querySelectorAll('.clarity-item--rang-label');
  const trackContainer = document.querySelector('.clarity-item--btn');
  const initialValueElement = document.querySelector('.clarity-item-head-value');

  let currentIndex = 0;
  const diamondClarities = ["I", "SI", "VS", "VVS", "IF", "FL"];
  // const diamondClarities = ["I1", "SI2", "SI1", "VS2", "VS1", "VVS2", "VVS", "IF", "FL"]; // Original 9 grades - commented for future use
  const numItems = diamondClarities.length;
  const transformX = 12; // Value of translateX in .clarity-item--slider

  function calculatePercentage(index) {
    return (index / (numItems - 1)) * 100;
  }

  function moveToIndex(index) {
    const percentage = calculatePercentage(index);
    sliderCircle.style.left = `calc(${percentage}% - ${transformX}px)`;
    updateUI(index);
    updateThumb(index);
    updateActiveLabel(index);
  }

  function updateUI(index) {
    images.forEach(img => img.style.display = 'none');
    contentItems.forEach(item => item.style.display = 'none');
    images[index].style.display = 'block';
    contentItems[index].style.display = 'block';
  }

  function updateThumb(index) {
    const percentage = calculatePercentage(index);
    sliderTrack.style.background = `linear-gradient(to right, rgb(0, 0, 0) ${percentage}%, rgb(255, 255, 255) ${percentage}%)`;
    sliderCircle.setAttribute('aria-valuenow', diamondClarities[index]);
  }

  function updateActiveLabel(index) {
    labels.forEach((label, i) => {
      if (i === index) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    });
  }

  // Drag functionality
  let isDragging = false;
  let startX, startLeft;

  function startDrag(event) {
    event.preventDefault();
    isDragging = true;
    startX = event.clientX || event.touches[0].clientX;
    startLeft = sliderCircle.getBoundingClientRect().left - trackContainer.getBoundingClientRect().left;

    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag);
    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('touchend', stopDrag);
  }

  function drag(event) {
    if (!isDragging) return;

    const x = event.clientX || event.touches[0].clientX;
    const newPosition = startLeft + x - startX;

    const trackWidth = sliderTrack.offsetWidth;
    const circleWidth = sliderCircle.offsetWidth;
    const minLeft = -transformX;
    const maxLeft = trackWidth - circleWidth + transformX;

    let constrainedPosition = Math.max(minLeft, Math.min(newPosition, maxLeft));
    let percentage = ((constrainedPosition + transformX) / (trackWidth - circleWidth + transformX * 2)) * 100;
    let index = Math.round((percentage / 100) * (numItems - 1));

    moveToIndex(index);
  }

  function stopDrag() {
    isDragging = false;
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('touchmove', drag);
    document.removeEventListener('mouseup', stopDrag);
    document.removeEventListener('touchend', stopDrag);
  }

  sliderCircle.addEventListener('mousedown', startDrag);
  sliderCircle.addEventListener('touchstart', startDrag);

  trackContainer.addEventListener('click', function (event) {
    const clickX = event.clientX - sliderTrack.getBoundingClientRect().left;
    const trackWidth = sliderTrack.offsetWidth;
    const circleWidth = sliderCircle.offsetWidth;
    const percentage = (clickX / (trackWidth - circleWidth)) * 100;
    const index = Math.round((percentage / 100) * (numItems - 1));

    moveToIndex(index);
  });

  labels.forEach((label, index) => {
    label.addEventListener('click', () => moveToIndex(index));
  });

  window.addEventListener('resize', function () {
    moveToIndex(currentIndex);
  });

  if (initialValueElement) {
    const initialValue = initialValueElement.textContent.trim();
    const initialIndex = diamondClarities.indexOf(initialValue);
    if (initialIndex !== -1) {
      currentIndex = initialIndex;
    }
  }

  moveToIndex(currentIndex);
});

// Cut file Js ----------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('slider');
  const images = [
    document.getElementById('image1'),
    document.getElementById('image2'),
    document.getElementById('image3')
  ];
  const btnInner = document.querySelector('.cut-item--btn-inner');
  const cutItemContent = document.querySelector('.cut-item--bottom-content');
  const contentInner = cutItemContent.querySelectorAll('.cut-item--content-inner');
  const textLabels = document.querySelectorAll('.cut-item--rang-label');
  const trackContainer = document.querySelector('.cut-item--btn');
  const initialValueElement = document.querySelector('.cut-item-head-value');

  const diamondCuts = ["Good", "VeryGood", "Excellent"];
  const numItems = diamondCuts.length;
  let currentIndex = 0;

  function calculatePercentage(index) {
    return (index / (numItems - 1)) * 100;
  }

  function moveToIndex(index) {
    const percentage = calculatePercentage(index);
    slider.style.left = `calc(${percentage}% - ${slider.offsetWidth / 2}px)`;
    updateSlider(index);
  }

  function updateSlider(index) {
    images.forEach((img, idx) => {
      img.style.display = (idx === index) ? 'block' : 'none';
    });

    const percentage = calculatePercentage(index);
    btnInner.style.background = `linear-gradient(to right, rgb(0, 0, 0) ${percentage}%, rgb(255, 255, 255) ${percentage}%)`;

    contentInner.forEach((item, idx) => {
      item.style.display = (idx === index) ? 'block' : 'none';
    });

    textLabels.forEach((label, idx) => {
      label.classList.toggle('active', idx === index);
    });
  }

  function setSliderValue(value) {
    slider.setAttribute('aria-valuenow', diamondCuts[value]);
    currentIndex = value;
    moveToIndex(value);
  }

  function onSliderMove(e) {
    e.preventDefault();

    const rect = btnInner.getBoundingClientRect();
    let offsetX;
    if (e.type === 'touchmove' || e.type === 'touchstart') {
      offsetX = e.touches[0].clientX - rect.left;
    } else {
      offsetX = e.clientX - rect.left;
    }
    offsetX = Math.max(0, Math.min(offsetX, rect.width));
    let value = Math.round((offsetX / rect.width) * (numItems - 1));
    setSliderValue(value);
  }

  function onTrackClick(e) {
    e.preventDefault();

    const rect = trackContainer.getBoundingClientRect();
    let offsetX;
    if (e.type === 'touchend' || e.type === 'touchstart') {
      offsetX = e.changedTouches[0].clientX - rect.left;
    } else {
      offsetX = e.clientX - rect.left;
    }
    offsetX = Math.max(0, Math.min(offsetX, rect.width));
    let value = Math.round((offsetX / rect.width) * (numItems - 1));
    setSliderValue(value);
  }

  slider.addEventListener('mousedown', (e) => {
    document.addEventListener('mousemove', onSliderMove);
    document.addEventListener('mouseup', () => {
      document.removeEventListener('mousemove', onSliderMove);
    });
  });

  slider.addEventListener('touchstart', (e) => {
    onSliderMove(e);
    document.addEventListener('touchmove', onSliderMove);
    document.addEventListener('touchend', () => {
      document.removeEventListener('touchmove', onSliderMove);
    });
  });

  trackContainer.addEventListener('click', onTrackClick);
  trackContainer.addEventListener('touchend', onTrackClick);

  textLabels.forEach((label, index) => {
    label.addEventListener('click', () => setSliderValue(index));
  });

  window.addEventListener('resize', () => {
    moveToIndex(currentIndex);
  });

  if (initialValueElement) {
    const initialValue = initialValueElement.textContent.trim();
    const initialIndex = diamondCuts.indexOf(initialValue);
    if (initialIndex !== -1) {
      setSliderValue(initialIndex);
    }
  } else {
    setSliderValue(0);
  }
});